import { ArrowLeft } from "lucide-react";

const BackButton = ({ onClick }: { onClick: { (): void } }) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "500",
      padding: "8px 12px",
      //   marginBottom: "24px",
      borderRadius: "8px",
      transition: "background 0.2s",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
    onMouseLeave={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
    <ArrowLeft size={20} />
    Back
  </button>
);
export default BackButton;
